module.exports = __webpack_public_path__ + "df57d307613f4093e6959122ba037f44.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_line_stacked_bar_1hour.png
// module id = 878
// module chunks = 7